export default __webpack_public_path__ + "static/media/illustration-features-tab-3.22a17467.png";